import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["chart"]
  static values = {
    data: Array
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const data = this.dataValue

    const categories = data.map(d => d.month)
    const series = data.map(d => d.net_payable)

    const options = {
      series: [{
        name: 'Net Payable',
        data: series
      }],
      chart: {
        type: 'area',
        height: '100%',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        parentHeightOffset: 0
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 90, 100]
        }
      },
      colors: ['#10B981'],
      xaxis: {
        categories: categories,
        labels: {
          style: {
            fontSize: '12px',
            colors: '#6B7280'
          }
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        labels: {
          formatter: function(value) {
            return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          },
          style: {
            fontSize: '12px',
            colors: '#6B7280'
          }
        }
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 4,
        padding: {
          bottom: 15
        }
      },
      tooltip: {
        y: {
          formatter: function(value) {
            return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }
      }
    }

    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }
}
